import { Record } from 'immutable';
import { INIT_SPACE_CREATION, SPACE_CREATION_ERROR, SPACE_CREATION_SUCCESS } from './action-types';

export const SpaceCreationState = new Record({
  message: ''
});

export function spaceCreationReducer(state = new SpaceCreationState(), action) {
  switch (action.type) {
    case INIT_SPACE_CREATION:
      return state.merge({
        message: 'Task deleted'
      });

    case SPACE_CREATION_ERROR:
    return state.merge({
      message: 'Failed'
    });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/create-space/reducer.js